import { getOrganisationName } from 'env'

/**
 * Determines if card management feature is enabled for the current organization
 * @returns boolean indicating if the organization can use card management
 */
export const isCardManagementEnabledForOrg = (): boolean => {
  const OrganisationName = getOrganisationName()?.toLowerCase()
  return OrganisationName === 'jisr' || OrganisationName === 'clickapps'
}
